const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 600,
    minWidth: 600,
    maxWidth: minWidth / 1.5,
    maxHeight:400
  },
  modalHeader: {
    fontWeight:'600!important',
    fontSize: '1.2rem!important',
  },
  contain:{
    overflowY: 'scroll',
  },
  form: {
    height: 490,
    overflowY: 'scroll'
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    minWidth:40,
  },
  close: {
    padding:0,
    minWidth:40,
  },
  flex: {
    flex: 1
  },
  summary: {
    padding: theme.spacing.unit
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/styles.js